const mpan_number_reducer = (state = 0, action) => {
	switch(action.type) {

		case 'UPDATEMPAN':
			return action.payload;

		default:
			return state;
	}
}

export default mpan_number_reducer;